import { render, staticRenderFns } from "./DeptPosition.vue?vue&type=template&id=645eb8f8&scoped=true"
import script from "./DeptPosition.vue?vue&type=script&lang=js"
export * from "./DeptPosition.vue?vue&type=script&lang=js"
import style0 from "./DeptPosition.vue?vue&type=style&index=0&id=645eb8f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645eb8f8",
  null
  
)

export default component.exports